import { ModalProps } from './types';
import { Overlay } from '../Overlay';
import { useState } from 'react';
import ClearOutlinedIcon from '@mui/icons-material/ClearOutlined';
import { StyledModal, StyledModalBorder } from './style';

export const Modal: React.FC<ModalProps> = ({
  closeModal,
  children,
  title,
  titleColor,
  titleSize,
  titleWeight,
  subtitle,
  subtitleColor,
  subtitleSize,
  modalColor,
  modalBorderColor,
  preview = false,
  fontFamily = 'sans-serif',
  showOverlay = true,
  showCloseButton = true,
  visible = true,
}) => {
  const [animationClass, setAnimationClass] = useState('');

  const closeModalHandler = () => {
    setAnimationClass('fadeout');
    closeModal();
  };

  return (
    <Overlay preview={preview} showOverlay={showOverlay} visible={visible}>
      <StyledModalBorder colors={modalBorderColor}>
        <StyledModal
          animate={{ scale: [0, 1], rotate: [12, 0] }}
          transition={{ duration: 0.5 }}
          className={animationClass}
          colors={modalColor}
          fontFamily={fontFamily}
          headerColors={titleColor}
          headerFontSize={titleSize}
          titleWeight={titleWeight}
        >
          {showCloseButton && (
            <ClearOutlinedIcon
              onClick={closeModalHandler}
              className="closeButton"
              style={{ color: subtitleColor }}
            />
          )}
          <h2>{title}</h2>
          <h5
            style={{
              color: subtitleColor,
              fontSize: `${subtitleSize}px`,
            }}
          >
            {subtitle}
          </h5>
          {children}
        </StyledModal>
      </StyledModalBorder>
    </Overlay>
  );
};
